import { ca } from '@cian/analytics';
import { IJsonQuery } from 'shared/json_query';

/**
 * Модальное окно-сторис с описанием фичи «Сравнение ЖК».
 * Открывается из баннера в выдаче и из тултипа флайта у кнопки сравнения.
 */
function trackCompareFlightModalEvent(
  jsonQuery: IJsonQuery,
  action: 'Show' | 'Scroll' | 'Close',
  label: 'description_modal' | 'pages',
  extra?: Record<string, unknown>,
) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJKPromo',
    action,
    label,
    page: {
      pageType: 'Listing',
      ...(extra ? { extra } : {}),
    },
    sc: jsonQuery,
  });
}

export function trackCompareFlightModalShow(jsonQuery: IJsonQuery) {
  trackCompareFlightModalEvent(jsonQuery, 'Show', 'description_modal');
}

/** Клик на «Далее»/«Назад», pageNumber — номер просмотренной страницы, с 1 */
export function trackCompareFlightModalScroll(jsonQuery: IJsonQuery, pageNumber: number) {
  trackCompareFlightModalEvent(jsonQuery, 'Scroll', 'pages', { page_number: pageNumber });
}

export function trackCompareFlightModalClose(jsonQuery: IJsonQuery) {
  trackCompareFlightModalEvent(jsonQuery, 'Close', 'pages');
}
